// extracted by mini-css-extract-plugin
export default {"container":"Section5_container__UjfJy","noTime":"Section5_noTime__otes9","qute":"Section5_qute__uFEyB","bodyText":"Section5_bodyText__nJExb"};